import logo from "./logo.svg";
import "./App.css";
import HeaderComponent from "./Components/Header/header";
import ImageSliderComponent from "./Components/Img-Slider/imgslider";
import NosotrosComponent from "./Components/Nosotros/nosotros";
import ImageDisplayerComponent from "./Components/ImgDisplayer/img-displayer";
import MejoresMarcas from "./Components/MejoresMarcas/MM";
import ComercializadoraCasar from "./Components/Comercializadora-Casar/Comercializadora-Casar";
import MasInfo from "./Components/MasInformacion/MasInformacion";
import Contactanos from "./Components/Contactanos/Contactanos";
import Footer from "./Components/Footer/footer";
import Buscador from "./Components/Buscador/Buscador";
import Mvv from "./Components/MVV/mvv";
import SolarSerdan from "./Components/SolarSerdan/SolarSerdan";
import Beneficios from "./Components/Beneficios/beneficios";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import CatalogoViewComponent from "./Views/Catalogo/catalogo";
import Refrigeracion from "./Components/Refrigeracion/refrigeracion";
import AceroSerdan from "./Components/AceroSerdan/AceroSerdan";
import ResumenViewComponent from "./Views/Resumen/resumen";
import LoginViewComponent from "./Views/Login/login";
import FideCfe from "./Components/Fide y cfe/FideCfe";
import TiendaOnline from "./Components/Tienda-Online/tienda-online";
import CotizadorViewComponent from "./Views/Cotizador/cotizador";

function App() {
   




  return (
    
    
    <Router>
      <div className="App">
        <Switch>
          <Route path="/catalogo">
            <CatalogoViewComponent />
          </Route>
          <Route path="/resumen">
            <ResumenViewComponent />
          </Route>
          <Route path="/iniciar-sesion">
            <LoginViewComponent />
          </Route>
          <Route path="/cotizador">
            <CotizadorViewComponent/>
          </Route>
          <Route path="/">
            <HeaderComponent />
            <div className="content">
              <ImageDisplayerComponent />
              <Buscador />
              <ImageSliderComponent />
              <NosotrosComponent />
              <Mvv /> 
              <ComercializadoraCasar />
              <MejoresMarcas />
              <TiendaOnline/>
              <SolarSerdan />
              <Beneficios /> 
              <Refrigeracion /> 
              <FideCfe/>
              <AceroSerdan /> 
              <Contactanos /> 
              
              <Footer />
            </div>
          </Route>
        </Switch>
      </div>
    </Router>
  );
  
}

export default App;
